var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1679 3.40754L3.79417 10.1138C2.85167 10.8629 2.2475 12.4459 2.45292 13.6301L4.06001 23.2484C4.35001 24.9642 5.99333 26.3538 7.73333 26.3538H21.2667C22.9946 26.3538 24.65 24.9521 24.94 23.2484L26.5471 13.6301C26.7404 12.4459 26.1363 10.8629 25.2058 10.1138L16.8321 3.41963C15.5392 2.38046 13.4488 2.38045 12.1679 3.40754Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.7292C16.1684 18.7292 17.5208 17.3767 17.5208 15.7083C17.5208 14.04 16.1684 12.6875 14.5 12.6875C12.8316 12.6875 11.4792 14.04 11.4792 15.7083C11.4792 17.3767 12.8316 18.7292 14.5 18.7292Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHome);
export default __webpack_public_path__ + "static/media/footer-home.f872e5e3.svg";
export { ForwardRef as ReactComponent };